module.exports = __webpack_public_path__ + "img/logo-darkbg1.864e1c68.svg";